module.exports = __webpack_public_path__ + "img/badge.fdc5ea90.png";